import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from 'components/Modal';
import PageTitle from 'components/PageTitle';

import errorImg from './img/error.png';
import './styles.scss';
import containerActions from '../actions';

class UploadProgress extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.done) {
      setTimeout(() => {
        this.props.fileUploaded(false);
      }, 1500);
    }
  }
  closeWindow = () => {
    this.props.fileUploaded(false);
    this.props.closeErrorWindow();
  }
  renderLoading = () => (
    <React.Fragment>
      <i className="icon-arrow-up-circle" />

      <div className="progress-process">
        <div className="process-status" style={{ width: `${this.props.progress}%` }} />
      </div>

      <PageTitle>
          Uploading document
      </PageTitle>

      <p className="progress-info">
         This process depends on your network connectivity
      </p>
    </React.Fragment>
  )

  renderDone = () => (
    <React.Fragment>
      <i className="icon-check" />
      <PageTitle>
        Document successfully uploaded
      </PageTitle>
    </React.Fragment>
  )

  renderError = () => (
    <React.Fragment>
      <img src={errorImg} alt="Error_pic" className="icon-error" />
      <PageTitle>
        {this.props.errorMessage}
      </PageTitle>
      <button className="upload-button" onClick={this.closeWindow}>Return</button>
    </React.Fragment>
  )

  render() {
    // console.log(this.props);
    return (
      <div className="progress-modal">
        <Modal isOpen={this.props.loading}>
          <div className="upload-progress">
            <div className="progress-wrapper">
              {this.props.done && this.renderDone()}
              {
                this.props.done !== true &&
                (this.props.errorDownload === true ? this.renderError() : this.renderLoading())
              }
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

UploadProgress.defaultProps = {
  progress: 0,
  done: false,
  loading: false,
  errorMessage: ''
};

UploadProgress.propTypes = {
  progress: PropTypes.number,
  loading: PropTypes.bool,
  fileUploaded: PropTypes.func.isRequired,
  done: PropTypes.bool,
  errorDownload: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  closeErrorWindow: PropTypes.func.isRequired
};

const mapToStateProps = state => ({
  progress: state.file.progress,
  done: state.file.done,
  loading: state.file.loading
});

export default connect(mapToStateProps, containerActions)(UploadProgress);



// WEBPACK FOOTER //
// ./src/pages/Upload/UploadProgress/index.js